class DecretoController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'decretoService']

  constructor: ($injector, @scope, pathService, @decretoService) ->
    super($injector)

    @loadingTracker = @promiseTracker()

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/ncm/"
    @modalDecreto = @openPopup("#{@url}decretos/modal.html", 'decretoModalController as ctrl')

    @loadDecretos()

  loadDecretos: ->
    @loadingTracker.addPromise @decretoService.getList((data) =>
      @listOfDecreto = data
    )

  adicionar: ->
    @modalDecreto(
      decreto: ->
        ano: (new Date).getFullYear()
    , (result) =>
      if result.ok
        @loadDecretos()
        @scope.tabController.reloadTab('ncm')
    )

  editar: (decreto) ->
    @modalDecreto(
      decreto: -> decreto
    , (result) =>
      if result.ok
        @loadDecretos()
        @scope.tabController.reloadTab('ncm')
    )

  remover: (decreto) ->
    Confirm.warning("Atenção",
      "Deseja realmente remover o Decreto Nº <strong>#{decreto.numero}</strong> de <strong>#{decreto.mes}/#{decreto.ano}</strong>? Esta ação <strong>não poderá</strong> ser desfeita.",
      {
        "Não": null
        "Sim": =>
          @decretoService.delete(decreto.id, (data) =>
            Alert.success("Decreto Nº <strong>#{decreto.numero}</strong> de <strong>#{decreto.mes}/#{decreto.ano}</strong> removido com sucesso.",
              "Sucesso!")
            @loadDecretos()
            @scope.tabController.reloadTab('ncm')
          )
      })


angular.module("eficienciaFiscalModule").controller("decretoController", DecretoController)


class DecretoModalController extends AbstractController
  @$inject = ['$injector', 'pathService', 'decretoService', '$uibModalInstance', 'decreto']

  constructor: ($injector, pathService, @decretoService, @modalInstance, decreto) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @decreto = angular.copy decreto
    @listOfMes = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro',
                  'Novembro', 'Dezembro']

  salvar: (form) ->
    if form.$valid
      callback = (retorno) =>
        Alert.success("Decreto Nº <strong>#{@decreto.numero}</strong> de <strong>#{@decreto.mes}/#{@decreto.ano}</strong> #{if @decreto.id then 'atualizado' else 'criado'} com sucesso.",
          "Sucesso!")
        @modalInstance.close(new Retorno(true))

      @submitTracker.addPromise(
        if @decreto.id
          @decretoService.update(@decreto, callback)
        else
          @decretoService.save(@decreto, callback)
      )

angular.module("eficienciaFiscalModule").controller("decretoModalController", DecretoModalController)